import React, { useState } from 'react';
import { Row, Col, Input } from 'antd';
import Box from '@iso/components/utility/box';
import { Colorpicker } from 'antd-colorpicker';
import Loader from '@iso/components/utility/loader';
import notification from '@iso/components/Notification';
import Button from '@iso/components/uielements/button';
import ContentHolder from '@iso/components/utility/contentHolder';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import Select, { SelectOption } from '@iso/components/uielements/select';
import { getBaseUrl, getCatalogUrl, openURL, slugify } from '@iso/lib/helpers/utility';
import CampaignsPageWrapper, { Fieldset, Label } from '@iso/containers/Integration/Leads/SingleCampaigns.styles.js';

import apiAccount from '@iso/services/repository/accountCustumer';
import apiCatalogo from '@iso/services/repository/catalogo_virtual';

const Option = SelectOption;
const CONFIG_TYPE = 'catalogo';

let blockStyles = {
    width: '100%',
    borderRadius: '4px',
    border: '1px solid #e9e9e9',
    boxShadow: 'none',
    height: '35px',
    margin: '5px 0',
    padding: '6px 10px '
};

const BASE_URL = getBaseUrl();
const contentBGImage = {display:'flex', alignItems:'center', justifyItems:'center', marginTop:'10px', border:'1px #DDD solid', flexDirection:'column', padding:'5px'};

export default function () {

    const [load, setLoad] = useState(true);
    const [config, setConfig] = useState({
        bg: '#badfc5',
        navBg: ''
    });

    const [disableSave, setDisableSave] = useState(false);

    React.useEffect(() => {
        loadData()
    }, []);

    function loadData() {
        setLoad(true);

        apiAccount.getConfig(CONFIG_TYPE).then((response) => {
            if (!response.data.error && response.data?.slug)
                setConfig(response.data)

            setLoad(false);
            setDisableSave(false);
        })
        .catch((err) => {
            console.error("ops! ocorreu um erro: " + err);
        });
    }

    function checkValues() {
        var thisReturn = true;
        const verifyParam = [
            // { name: 'emissao', label: 'Quando emitir Nota Fiscal (NFC-e)' },
            // { name: 'ind_presenca', label: 'Indicador de presença padrão' },
        ];

        verifyParam.forEach(elemnt => {
            if (!config[elemnt.name] && thisReturn) {
                notification('error', `Campo ${elemnt.label} não pode ser vazio`)
                thisReturn = false;
            }
        })
        return thisReturn;
    }

    const handleSubmit = () => {
        if (checkValues()) {

            setLoad(true);

            const formData = new FormData(document.getElementById("formConfigData"));

            apiCatalogo.updateCatalogoVirtualData(formData).then(r => {
                setLoad(false);
                if (!(r.data.error) && r.data === "ok") {
                    loadData();
                    notification('success', 'Configuração Salva')
                }
                else
                    notification('error', 'Erro ao salvar configuração');
            })
        }
    }

    const openMyCatalog = () => {
        openURL(getCatalogUrl(config), '_blank');
    }

    return (load) ? <Loader /> : (
        <LayoutWrapper>
            
            <PageTitleBar title="Configurações do Catálogo Virtual" />
            <div style={{ backgroundColor: '#fff', padding: '0 16px 12px 16px', marginBottom: 10, display: 'flex', gap: 8, justifyContent: 'flex-end', width: '100%' }}>
              <Button type="primary" onClick={openMyCatalog} className="saveBtn">
                <span>Acessar Catálogo</span>
              </Button>
            </div>
            <Box style={{ border: 'none', boxShadow: 'none' }}>
                <CampaignsPageWrapper className="editView">
                    <div className="PageContent">
                        <div className="BillingInformation">
                            <Box>
                                <ContentHolder>
                                    <form id='formConfigData'>

                                        <Input value={(config?.bg != null) ? config?.bg : ''} name="bg" type='hidden' />
                                        <Input value={(config?.slug != null) ? config?.slug : ''} name="slug" type='hidden' />
                                        <Input value={(config?.navBg != null) ? config?.navBg : ''} name="navBg" type='hidden' />
                                        <Input value={(config?.navColor != null) ? config?.navColor : ''} name="navColor" type='hidden' />
                                        <Input value={(config?.hasDomain != null) ? config?.hasDomain : ''} name="hasDomain" type='hidden' />
                                        <Input value={(config?.menuColor != null) ? config?.menuColor : ''} name="menuColor" type='hidden' />
                                        {/* <Input value={(config?.firstColor != null) ? config?.firstColor : ''} name="firstColor" type='hidden' />
                                        <Input value={(config?.secondColor != null) ? config?.secondColor : ''} name="secondColor" type='hidden' /> */}
                                        <Input value={(config?.itensPerPage != null) ? config?.itensPerPage : ''} name="itensPerPage" type='hidden' />

                                        <Row gutter={24}>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Nome da loja</Label>
                                                    <Input value={(config.name) ? config.name : ''} name='name'
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, name: e.target.value, slug: slugify(e.target.value) } }); }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Nome da loja na URL</Label>
                                                    <Input disabled={true} value={(config.slug) ? config.slug : ''} />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Cor de fundo</Label>
                                                    <Colorpicker
                                                        popup
                                                        blockStyles={blockStyles}
                                                        value={(config.bg) ? config.bg : '#badfc5'}
                                                        onChange={(e) => {
                                                            setConfig(prevState => {
                                                                return { ...prevState, bg: e.hex }
                                                            });
                                                        }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Cor de fundo do menu</Label>
                                                    <Colorpicker
                                                        popup
                                                        blockStyles={blockStyles}
                                                        value={(config.navBg) ? config.navBg : ''}
                                                        onChange={(e) => {
                                                            setConfig(prevState => {
                                                                return { ...prevState, navBg: e.hex }
                                                            });
                                                        }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Cor texto do menu</Label>
                                                    <Colorpicker
                                                        popup
                                                        blockStyles={blockStyles}
                                                        value={(config.navColor) ? config.navColor : ''}
                                                        onChange={(e) => {
                                                            setConfig(prevState => {
                                                                return { ...prevState, navColor: e.hex }
                                                            });
                                                        }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            {/* <Col span={6}>
                                                <Fieldset>
                                                    <Label>Cor principal</Label>
                                                    <Colorpicker
                                                        popup
                                                        blockStyles={blockStyles}
                                                        value={(config.firstColor) ? config.firstColor : ''}
                                                        onChange={(e) => {
                                                            setConfig(prevState => {
                                                                return { ...prevState, firstColor: e.hex }
                                                            });
                                                        }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Cor secundária</Label>
                                                    <Colorpicker
                                                        popup
                                                        blockStyles={blockStyles}
                                                        value={(config.secondColor) ? config.secondColor : ''}
                                                        onChange={(e) => {
                                                            setConfig(prevState => {
                                                                return { ...prevState, secondColor: e.hex }
                                                            });
                                                        }}
                                                    />
                                                </Fieldset>
                                            </Col> */}
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Cor ícone menu no celular</Label>
                                                    <Colorpicker
                                                        popup
                                                        blockStyles={blockStyles}
                                                        value={(config.menuColor) ? config.menuColor : ''}
                                                        onChange={(e) => {
                                                            setConfig(prevState => {
                                                                return { ...prevState, menuColor: e.hex }
                                                            });
                                                        }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Link Instagram</Label>
                                                    <Input type='text' value={(config.instagram) ? config.instagram : ''} name='instagram'
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, instagram: e.target.value } }); }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Link Facebook</Label>
                                                    <Input type='text' value={(config.facebook) ? config.facebook : ''} name='facebook'
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, facebook: e.target.value } }); }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Link Youtube</Label>
                                                    <Input type='text' value={(config.youtube) ? config.youtube : ''} name='youtube'
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, youtube: e.target.value } }); }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Quantidade de produtos por página?</Label>
                                                    <Select
                                                        value={(typeof (config?.itensPerPage) !== 'undefined') ? config?.itensPerPage : '9'}
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, itensPerPage: e } }) }}
                                                    >
                                                        <Option value="3">3</Option>
                                                        <Option value="6">6</Option>
                                                        <Option value="9">9</Option>
                                                        <Option value="12">12</Option>
                                                        <Option value="15">15</Option>
                                                    </Select>
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Você tem domínio próprio?</Label>
                                                    <Select
                                                        value={(typeof (config?.hasDomain) !== 'undefined') ? config?.hasDomain : 'N'}
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, hasDomain: e } }) }}
                                                    >
                                                        <Option value="N">Não</Option>
                                                        <Option value="S">Sim</Option>
                                                    </Select>
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Seu código do Google Analytics</Label>
                                                    <Input value={config.googleAnalytics} name='googleAnalytics'
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, googleAnalytics: e.target.value} }); }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Seu código do Facebook Pixel</Label>
                                                    <Input value={config.facebookPixel} name='facebookPixel'
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, facebookPixel: e.target.value} }); }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Seu código do Microsoft Clarity</Label>
                                                    <Input value={config.microsoftClarity} name='microsoftClarity'
                                                        onChange={(e) => { setConfig(prevState => { return { ...prevState, microsoftClarity: e.target.value} }); }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            <Col span={6}>
                                                <Fieldset>
                                                    <Label>Logotipo</Label>
                                                    <Input
                                                        type="file"
                                                        name="logo"
                                                        accept=".jpg,.jpeg,.png"
                                                        style={{ height: '45px' }}
                                                    />
                                                </Fieldset>
                                            </Col>
                                            {
                                                config.hasDomain === 'S' ?
                                                    <Col span={6}>
                                                        <Fieldset>
                                                            <Label>URL do seu domínio</Label>
                                                            <Input type='text' value={(config.domain) ? config.domain : ''} name='domain'
                                                                onChange={(e) => { setConfig(prevState => { return { ...prevState, domain: e.target.value } }); }}
                                                            />
                                                        </Fieldset>
                                                    </Col>
                                                : <></>
                                            }
                                            {
                                                config?.logo && config.logo.length > 0 ?
                                                    <div style={contentBGImage}>
                                                        <img src={BASE_URL + '/display/send/temp/' + config?.logo } style={{ maxWidth: 300, maxHeight: 300 }} />
                                                        <br/>
                                                        {/* <Popconfirm title="Deseja realmente remover?" onConfirm={()=>handleDeleteItemBgImage('logo')}>
                                                            <BiX style={{ cursor: 'pointer', fontSize:'22px' }} />
                                                        </Popconfirm> */}
                                                    </div>
                                                :
                                                    <></>
                                            }
                                        </Row>
                                    </form>
                                </ContentHolder>
                            </Box>
                        </div>
                    </div>
        </CampaignsPageWrapper>
      </Box>
        </LayoutWrapper>
    );
}